// Popup.jsx
import React from 'react';
import Draggable from 'react-draggable';

const Popup = ({ children, onClose }: any) => {
  return (
    <Draggable handle=".draggable-handle">
      <div className="modal-overlay fixed inset-0 flex items-center justify-center">
        <div
          className="relative bg-white border shadow-lg min-w-[50%] max-w-[65%] max-h-[70%] flex flex-col"
        >
          {/* Fixed header */}
          <div className="sticky top-0 w-full min-h-8 h-8 bg-gray-800 cursor-move draggable-handle flex items-center">
            <button
              className="absolute right-4 text-xl text-gray-500 hover:text-white"
              onClick={onClose}
            >
              &times;
            </button>
          </div>

          {/* Scrollable content */}
          <div
            className="overflow-y-auto p-6 flex-1"
            style={{ maxHeight: "calc(90% - 2rem)" }}
          >
            {children}
          </div>
        </div>
      </div>
    </Draggable>
  );
};


export default Popup;
